module.exports = __webpack_public_path__ + "img/TYPEOFPACKAGES.7e08fee8.png";